{
  "admin": {
    "appName": "Admin Portal"
  },
  "partner": {
    "appName": "Partner Portal"
  },
  "platform": {
    "appName": "Platform Admin"
  },
  "shell": {
    "empty": {
      "description": "There is nothing here yet.",
      "title": "No content"
    },
    "error": {
      "description": "Something went wrong.",
      "retry": "Retry",
      "title": "Error"
    },
    "nav": {
      "home": "Home"
    }
  }
}
